/**
 * @file
 * Helper function to strip white space from table cells.
 */
(function (Drupal) {
  Drupal.behaviors.halifaxTableHead = {
    attach: function (context) {
      const headers = Array.from(context.querySelectorAll('.c-table__cell'));
      headers.forEach((el) => {
        el.innerHTML = el.innerHTML.trim(); // eslint-disable-line no-param-reassign
      });
    },
  };
})(Drupal);
